module.exports = __webpack_public_path__ + "static/media/photo63.599d22cf.jpg";